import { Skeleton } from '@/components/ui/skeleton'
import { ProductGrid } from '../components/ProductGrid'
import { useShopProducts } from '../hooks/useShopProducts'
import { useDocumentMeta } from '@/lib/useDocumentMeta'

export function ShopPage() {
  const { products, loading, error } = useShopProducts()
  useDocumentMeta('Shop', 'Support One Day Dance with gear, apparel, and limited-run merch — shipped direct via Printify.')

  return (
    <div className="container mx-auto px-4 py-12">
      <div className="mb-8">
        <h1 className="text-3xl font-bold tracking-tight">Merch</h1>
        <p className="mt-2 text-muted-foreground">
          Support ODD — gear, apparel, and more.
        </p>
      </div>

      {loading ? (
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className="space-y-2">
              <Skeleton className="aspect-square w-full rounded-lg" />
              <Skeleton className="h-4 w-3/4" />
              <Skeleton className="h-3 w-1/2" />
            </div>
          ))}
        </div>
      ) : error ? (
        <div className="py-20 text-center text-destructive">{error}</div>
      ) : (
        <ProductGrid products={products} />
      )}
    </div>
  )
}
